
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.743 2C5.25 2 4 3.19 4 4.61v15.217C4 21.02 5.031 22 6.286 22h13.028c.36 0 .686-.31.686-.652V6.565c-.002-.383-.294-.655-.686-.652-.66 0-1.371-.677-1.371-1.304 0-.628.711-1.305 1.371-1.305.363.005.686-.307.686-.652 0-.344-.323-.657-.686-.652H6.743zm0 1.304H16.95c-.24.386-.379.833-.379 1.305s.14.918.379 1.304H6.743c-.66 0-1.372-.677-1.372-1.304 0-.628.712-1.305 1.372-1.305zM5.37 6.857c.406.228.876.36 1.372.36h11.886v13.479H6.286c-.519 0-.915-.377-.915-.87V6.857zm2.515 2.97c-.379 0-.686.291-.686.651 0 .36.307.652.686.652h8.228c.379 0 .686-.292.686-.652 0-.36-.307-.652-.686-.652H7.886zm0 3.477c-.379 0-.686.292-.686.653 0 .36.307.652.686.652h8.228c.379 0 .686-.292.686-.652 0-.36-.307-.653-.686-.653H7.886zm0 3.479c-.379 0-.686.292-.686.652 0 .36.307.652.686.652h8.228c.379 0 .686-.292.686-.652 0-.36-.307-.652-.686-.652H7.886z","fill":"#9AA0B5"}})])
          )
        }
      }
    